import { useCallback, useRef, useState } from 'react';
import ToastUtils from '@/utils/ToastUtils';
import useMultimodalUtils from './useMultimodalUtils';
import useMultimodalHistory from './useMultimodalHistory';
import useMultimodalVideoHandlers from './useMultimodalVideoHandlers';
import grtStore from '@/store/grtStore';

/**
 * 多模态学习引用管理 Hook
 * 负责管理多模态引用数据及请求方法
 */

const useMultimodalReference = () => {
    // prefer global store for multimodal reference when available
    const multimodalStore = grtStore?.multimodalStore;
    const [multimodalReference, changeMultimodalReference] = useState(
        multimodalStore?.multimodalReference ?? null
    );
    const multimodalReferenceRef = useRef(multimodalStore?.multimodalReference ?? null);

    // 使用其他 hook
    const utils = useMultimodalUtils();
    const history = useMultimodalHistory();
    const videoHandlers = useMultimodalVideoHandlers();

    const setMultimodalReference = useCallback((data) => {
        // update local state/ref for immediate consistency
        changeMultimodalReference(data);
        multimodalReferenceRef.current = data;

        // also persist to global store if available
        if (multimodalStore && typeof multimodalStore.setMultimodalReference === 'function') {
            try {
                multimodalStore.setMultimodalReference(data);
            } catch (e) {
                // ignore store write errors
            }
        }
    }, [multimodalStore]);

    // multimodal learning handled via unified chat flow elsewhere; removed request helper


    return {
        // 引用数据管理
        multimodalReference,
        setMultimodalReference,
        multimodalReferenceRef,
        // 历史记录相关（从 useMultimodalHistory）
        handleMultimodalHistoryWithUI: history.handleMultimodalHistoryWithUI,
        isMultimodalHistorySkill: history.isMultimodalHistorySkill,
        createOpenHistoryMultimodalList: history.createOpenHistoryMultimodalList,
        // 工具方法（从 useMultimodalUtils）
        isSuccessStatus: utils.isSuccessStatus,
        isProcessingStatus: utils.isProcessingStatus,
        isFailedStatus: utils.isFailedStatus,
        extractStatus: utils.extractStatus,
        getTaskType: utils.getTaskType,
        convertTaskStatusToCardStatus: utils.convertTaskStatusToCardStatus,
        initializeCardStatusFromTaskList: utils.initializeCardStatusFromTaskList,
        processPodcastTranscript: utils.processPodcastTranscript,
        buildDisplayData: utils.buildDisplayData,
        processMultimodalReferences: utils.processMultimodalReferences,
        // 视频处理方法（从 useMultimodalVideoHandlers）
        createVideoHandlers: videoHandlers.createVideoHandlers
    };
};

export default useMultimodalReference;

